import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import EmptyLine from "../EmptyLine";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultBody from "../../../components/table/ResultBody";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import {useModal} from "../../../context/ModalContext";
import CheckCSName from "../CheckCSName";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultView from "../../../components/ResultView";

export function B30({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    const {openModal} = useModal()

    switch (row.error_id) {
        case MessageCodes.Internal.SOF01.error_id: {
            return (
                <>
                    <ResultText>
                        Ineffective flow areas do not act consistently at the US and DS cross sections of the following structures for the listed profiles.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(20)}}>Structure</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(30)}}>Profile</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            <CheckCSName
                                                csName={(
                                                    <>
                                                        {r.type} at RS {r.cross_section}
                                                    </>
                                                )}
                                                csNameVal={r.cross_section}
                                            />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'left'}}>{r.profiles?.join(', ')}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
    }
}